import { NOTIFICATION_INBOX_TABS } from "../config/notifications.config.js";
import { isNotificationUnread } from "./format-notification-display.js";
import { sortNotificationsByReadAtDesc } from "./sort-notifications-by-read-at-desc.js";

/**
 * Essencial já lida (histórico da aba Lidas).
 * @param {Object} [notification]
 * @returns {boolean}
 */
export function isEssentialReadNotification(notification) {
  return (
    Boolean(notification?.isEssential) && !isNotificationUnread(notification)
  );
}

/**
 * Filtra a lista conforme a aba do inbox.
 * - `pending`: todas não lidas
 * - `essential-read`: todas as essenciais lidas, ordenadas por readAt desc (sem slice — exibição controlada pelo componente)
 *
 * @param {Object[]} [notifications]
 * @param {string} [tab]
 * @returns {Object[]}
 */
export function filterNotificationsByInboxTab(
  notifications,
  tab = NOTIFICATION_INBOX_TABS.pending,
) {
  const list = Array.isArray(notifications) ? notifications : [];

  if (tab === NOTIFICATION_INBOX_TABS.essentialRead) {
    return sortNotificationsByReadAtDesc(list.filter(isEssentialReadNotification));
  }

  return list.filter((item) => isNotificationUnread(item));
}
